module.exports = __webpack_public_path__ + "static/media/collaboration.fe34ba39.jpg";